module.exports = __webpack_public_path__ + "media/images/lp/sv/img/pc/contents-bg-wide-94d5d3eef5b79b5d255247b88ec785d2.png";